import { v3 } from '@adobe/edex/frontend/api/v3';

const baseURL = '/ratings';

export function rateEntity(data) {
  return v3.post(`/ratings`, data);
}
